import { MarketTemplate } from "../data";
/* tslint:disable:no-null-keyword */
export var emptyMarket = {
    id: "",
    name: "",
    betslipLine: "",
    marketType: {
        id: "",
        name: "",
        isCastMarket: false
    },
    sportId: "",
    leagueId: "",
    startDate: "",
    title: null,
    participantMapping: null,
    eventId: "",
    entityType: 1,
    isLive: false,
    isSuspended: false,
    liveData: null,
    metadata: {},
    tags: [""],
    groups: [""],
    inMarketGroups: [{
            id: "",
            sortingKey: 0
        }],
    castMarkets: null,
    template: MarketTemplate.ThreeBox,
    selections: []
};
//# sourceMappingURL=emptyMarket.js.map